import React, { useContext, useState } from "react";
import { observer } from "mobx-react-lite";

import {
  IonIcon,
  IonButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonList,
  IonPage,
  IonTitle,
  IonToolbar,
  IonProgressBar,
  IonSearchbar,
  isPlatform,
  useIonModal,
  IonImg,
  IonItem,
  IonLabel,
  IonText,
} from "@ionic/react";

import { add, arrowBack } from "ionicons/icons";

import PhoneNumbersListItem from "./components/PhoneNumbersListItem";
import PhoneNumberDetail from "./components/PhoneNumberDetail";

import * as Models from "../../models";
import { SessionContext } from "../../session";

const PhoneNumbersPage: React.FC = observer(() => {
  const [searchText, setSearchText] = useState("");
  const [selectedItem, setSelectedItem] = useState<Models.PhoneNumber>();

  const handleDismiss = () => {
    dismiss();
  };

  const session = useContext(SessionContext);

  const [present, dismiss] = useIonModal(PhoneNumberDetail, {
    session: session,
    phoneNumber: selectedItem,
    onDismiss: handleDismiss,
  });

  if (!session) {
    return <></>;
  }

  const phoneNumbers = session.phoneNumbers?.data?.filter(
    (phoneNumber) =>
      ((phoneNumber.name ?? "").trim() !== "" &&
        (phoneNumber.name ?? "")
          .toUpperCase()
          .includes((searchText ?? "").toUpperCase())) ||
      ((phoneNumber.phone ?? "").trim() !== "" &&
        (phoneNumber.phone ?? "")
          .toUpperCase()
          .includes((searchText ?? "").toUpperCase()))
  );

  return (
    <IonPage>
      <IonHeader
      //className="ion-no-border"
      >
        <IonToolbar color="primary">
          <IonButtons slot="start">
            {session.windowSize === "small" ? (
              <>
                {/*<IonBackButton defaultHref={`/conversations`}></IonBackButton>*/}
                <IonButton routerLink="/admin">
                  <IonIcon icon={arrowBack} />
                </IonButton>
              </>
            ) : (
              <></>
            )}
          </IonButtons>
          <IonTitle>Phone Numbers</IonTitle>
          <IonButtons slot="end">
            <IonButton
              shape="round"
              expand="block"
              size="large"
              fill="solid"
              color="light"
              onClick={() => {
                setSelectedItem(new Models.PhoneNumber(session, "phoneNumberProfiles"));
                present({ cssClass: "modal-create-view" });
              }}
            >
              <IonIcon icon={add} />
            </IonButton>
          </IonButtons>
        </IonToolbar>
      </IonHeader>

      <IonContent fullscreen>
        <IonProgressBar hidden={!session.phoneNumbers?.loading} type="indeterminate" />
        <IonSearchbar
          color="light"
          value={searchText}
          onIonChange={(e) => setSearchText(e.detail.value!)}
        ></IonSearchbar>
        <IonList>
          {phoneNumbers && phoneNumbers.length > 0
            ? phoneNumbers.map((item) => (
                <PhoneNumbersListItem
                  key={item.id}
                  phoneNumber={item}
                  onSelectItem={(item) => {
                    setSelectedItem(item);
                    present({ cssClass: "modal-edit-view" });
                  }}
                />
              ))
            : (
                <IonItem style={{}} lines="none">
                  <IonLabel className="ion-text-center">
                    <IonImg
                      style={{
                        maxWidth: "250px",
                        margin: "auto",
                        marginTop: "69px",
                      }}
                      src={
                        (searchText ?? "") === ""
                          ? "/assets/images/artboard006.png"
                          : "/assets/images/artboard008.png"
                      }
                    />
                    <p>
                      <strong>
                        <IonText
                          color="dark"
                          style={{
                            fontSize: "20px",
                          }}
                        >
                          {(searchText ?? "") === ""
                            ? ""
                            : " No Search Results"}
                        </IonText>
                      </strong>
                    </p>
                    <p
                      style={{
                        marginTop: "5px",
                      }}
                    >
                      <IonText
                        color="medium"
                        style={{
                          fontSize: "16px",
                        }}
                      ></IonText>
                    </p>
                  </IonLabel>
                </IonItem>
              )}
        </IonList>
      </IonContent>
    </IonPage>
  );
});

export default PhoneNumbersPage;
